/**
 * @generated SignedSource<<3edfba817bea3e7a379cf32087432f21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpAuctionItems_viewer$data = {
  readonly auctionHomepageModuleItems: ReadonlyArray<{
    readonly browseUrl: string | null;
    readonly categoryCode: string | null;
    readonly contemporaryTrackingString: string;
    readonly firstPhotoWebPath: string | null;
    readonly localizedPdpUrl: string | null;
    readonly seller: {
      readonly serviceId: string | null;
    } | null;
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"AuctionCountdown_item">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFavoritesProvider_viewer">;
  readonly " $fragmentType": "HpAuctionItems_viewer";
};
export type HpAuctionItems_viewer$key = {
  readonly " $data"?: HpAuctionItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpAuctionItems_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "auctionItemsCount"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpAuctionItems_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemCount",
          "variableName": "auctionItemsCount"
        }
      ],
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "auctionHomepageModuleItems",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": "master"
            }
          ],
          "kind": "ScalarField",
          "name": "firstPhotoWebPath",
          "storageKey": "firstPhotoWebPath(size:\"master\")"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "localizedPdpUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contemporaryTrackingString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "page",
              "value": "searchAndBrowse"
            }
          ],
          "kind": "FragmentSpread",
          "name": "AuctionCountdown_item"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFavoritesProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "1c5de92117f44aee9f6fc82b7c40e7e5";

export default node;
